import { render, staticRenderFns } from "./CriterioSelectBenefits.vue?vue&type=template&id=14af4eeb"
import script from "./CriterioSelectBenefits.vue?vue&type=script&lang=js"
export * from "./CriterioSelectBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports